import http from 'core/services/http';
import Config from 'core/config';

class RoomRosterService {

  static getStudentsList(roomId, filterParams, searchValue, pageParams) {
    const filters = `${filterParams && filterParams.notSeated ? '&notSeated=1' : ''}${filterParams && filterParams.mismatch ? '&mismatch=1' : ''}${filterParams && filterParams.accomRosterFlag ? '&accomRosterFlag=1' : ''}`;
    const searchParam = searchValue ? `&name=${searchValue}` : '';
    const page = `${pageParams && pageParams.limit ? `&limit=${pageParams.limit}` :  ''}${pageParams && pageParams.offset ? `&offset=${pageParams.offset}` : ''}`
    return http.get(`${Config.apiUrl}/query/registrations?roomId=${roomId}${filters}${searchParam}${page}`);
  }
  static unassignExaminees(roomId, data) {
    return http.put(`${Config.apiUrl}/room/${roomId}/unassignregs`, data);
  }
}

export default RoomRosterService;
